"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleReportEvents = void 0;
const rxjs_1 = require("rxjs");
const sok_types_1 = require("@caddigital/sok-types");
const ReportActions = require("../../../actions/reports/list");
const eventTypes = require("../eventTypes");
const utils_1 = require("../utils");
function handleReportEvents(action) {
    switch (action.payload.event) {
        case eventTypes.GENERATE_REPORT_SUCCESS: {
            const event = action.payload;
            return (0, utils_1.validate)(action.payload, eventTypes.iReportStatusEvent, () => (0, rxjs_1.of)(ReportActions.updateReportStatus({
                status: sok_types_1.Reports.COMPLETED,
                reportUuid: event.message.reportUuid,
                downloadLink: event.message.downloadLink
            })));
        }
        case eventTypes.GENERATE_REPORT_FAILED: {
            const event = action.payload;
            return (0, utils_1.validate)(action.payload, eventTypes.iReportStatusEvent, () => (0, rxjs_1.of)(ReportActions.updateReportStatus({
                status: sok_types_1.Reports.FAILED,
                reportUuid: event.message.reportUuid
            })));
        }
        default:
            return rxjs_1.EMPTY;
    }
}
exports.handleReportEvents = handleReportEvents;
//# sourceMappingURL=report.js.map